<template>
    <v-card class="mx-auto" light :loading="loading">
        <v-card-title>Dependencias - Áreas
            <div class="flex-grow-1"></div>
            <v-card-actions>
                <v-btn small color="blue-grey" dark @click="agregar = true">Agregar</v-btn>
            </v-card-actions>
        </v-card-title>
        <div style=" display: flex; align-items: center; justify-content: end;"> 
        <v-col cols="6" >
            <v-text-field v-model="search" append-icon="fa-search" label="Buscar" single-line hide-details></v-text-field>
        </v-col>
        </div>
        <v-card-text>
            <v-data-table
            :headers="headers"
            :items="dependencias"
            :search="search"
            locale="es-mx"
            :footer-props="{
                'items-per-page-all-text':'Todos',
                'items-per-page-text':'Columnas'
            }"
            >

            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="item in items" :key="item.name">
                    <td>
                        <menu-item 
                        :items="menuItems"
                        :id="item._id"
                        @menuAction="menuAction"
                        />
                    </td>
                    <td>{{item.nombre}}</td>
                    <td v-if="item.tipo == 'area'">Área</td>
                    <td v-else>Comisión</td>
                    <td>{{item.titular.usuario.titulo}} {{item.titular.usuario.nombreCompleto}}</td>
                    <td>{{item.titular.puesto}}</td>
                </tr>
                </tbody>
            </template>
            </v-data-table>
        </v-card-text>
       
        <div style="padding:20px">
            <logs :logs="logs"></logs>
        </div>
        <agregar-dependencia 
        v-if="agregar" 
        :mostrar="agregar" 
        @cancelar="agregar=false" 
        @dependenciaAgregada="dependenciaAgregada"
        />
        <modificar-dependencia 
        v-if="modificar.mostrar" 
        :mostrar="modificar.mostrar" 
        :dependenciaPadre="modificar.dependencia" 
        @cancelar="modificar.mostrar=false" 
        @dependenciaModificada="dependenciaModificada"
        />
    </v-card>
</template>

<script>
import axios from 'axios'
import { mapGetters} from 'vuex'
import MenuItem from '../components/menus/MenuItem'
import AgregarDependencia from '../components/dependencias/agregarDependencia'
import ModificarDependencia from '../components/dependencias/modificarDependencia'
import logs from "../components/logs/logs.vue"
export default {
    components: {
        MenuItem,
        AgregarDependencia,
        ModificarDependencia,
        logs
    },
    data: () => ({
        loading: false,
        search: null,
        agregar: false,
        modificar: {
            mostrar: false,
            dependencia: null
        },
        headers: [
            { text: '', value: 'options', sortable: false },
            { text: 'Nombre', value: 'nombre' },
            { text: 'Tipo', value: 'tipo' },
            { text: 'Titular', value: 'titular' },
            { text: 'Puesto', value: 'puesto' }
        ],
        dependencias: [],
        menuItems:[
            // {text:'Ver perfil', action: 'verPerfil'},
            {text:'Integrantes', action: 'verIntegrantes'},
            {text:'Modificar datos', action: 'modificarDatos'},
        ],
        logs:[]

    }),
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken", "role"
        ])
    },
    created(){
        if(this.role!='super-admin') this.$router.push('/oficios');
        else{
        this.loading = true;
        axios.get(this.httpURL+'/dependencias',
            {headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                if( res.data.ok ){
                    this.dependencias = res.data.dependencias;
                    this.logs=res.data.logs;
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                }
                this.loading = false;
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                this.loading = false;
            });
        }
    },
    methods: {
        menuAction(action, id){
            switch(action){
                case 'modificarDatos':
                    let dependencia = this.dependencias.find(x=>x._id == id);
                    this.modificar.dependencia = dependencia;
                    this.modificar.mostrar = true;
                    break;
                case 'verIntegrantes':
                    this.$router.push('/dependencias/'+id);
                    break;

            }
            // console.log(action, id);
        },
        dependenciaAgregada({dependencia,log}){
            this.dependencias.push(dependencia);
            this.logs.unshift(log)
            this.agregar = false;
        },
        dependenciaModificada({dependencia, log}){
            let index = this.dependencias.findIndex(x=>x._id == dependencia._id);
            this.dependencias.splice(index,1,dependencia);
            this.modificar.dependencia = null;
            this.modificar.mostrar = false;
            this.logs.unshift(log)
        }
    }
}
</script>
